import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

/**
 * Shared confirmation modal for exiting an in-progress exam / review session.
 * Light + dark mode + mobile-friendly. Stacks buttons on small screens.
 */
export default function ExitConfirmDialog({
  open,
  onCancel,
  onConfirm,
  mode = "review", // "exam" | "review" | "smart-review"
}) {
  const label =
    mode === "exam"
      ? "exam"
      : mode === "smart-review"
      ? "smart review"
      : "review";

  return (
    <Dialog open={open} onOpenChange={(v) => (!v ? onCancel?.() : null)}>
      <DialogContent className="max-w-md" data-testid="exit-confirm-dialog">
        <DialogHeader>
          <div className="mx-auto mb-2 h-12 w-12 rounded-full bg-amber-100 dark:bg-amber-500/15 grid place-items-center">
            <AlertTriangle
              className="w-6 h-6 text-amber-600 dark:text-amber-400"
              strokeWidth={2}
            />
          </div>
          <DialogTitle className="font-display text-center text-xl">
            Exit {label} session?
          </DialogTitle>
          <DialogDescription className="text-center">
            Your current progress will be saved, but this session will end. You
            can return any time to continue practicing.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="flex flex-col-reverse sm:flex-row gap-2 sm:gap-2">
          <Button
            variant="outline"
            className="w-full sm:w-auto h-11"
            onClick={onCancel}
            data-testid="exit-confirm-stay-btn"
          >
            Stay
          </Button>
          <Button
            className="w-full sm:w-auto h-11 bg-rose-600 hover:bg-rose-700 text-white"
            onClick={onConfirm}
            data-testid="exit-confirm-leave-btn"
          >
            Exit {label}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
